// @core/api/endpoints/payment/handle_provider_webhook.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  HandleProviderWebhookRequest,
  HandleProviderWebhookResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Handle provider webhook
 * Receives and processes incoming webhooks from payment providers. Verifies signature, normalizes event, and updates payment state.
 */
export async function HandleProviderWebhook(
  providerCode: string,
  data: HandleProviderWebhookRequest,
  options?: RequestOptions
): Promise<HandleProviderWebhookResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/webhooks/:providerCode`;
  requestPath = requestPath.replace(':providerCode', encodeURIComponent(providerCode));
  const requestOptions = options;
  return client.post<HandleProviderWebhookResponse>(requestPath, data, requestOptions);
}
